import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ResolvableServiceUsageForm_ResolvableServiceUsage_Fragment =
  graphql(`
    fragment ResolvableServiceUsageForm_ResolvableServiceUsage_Fragment on ResolvableServiceUsage {
      _id
      contentOriginId
      serviceUsageOrigin {
        missionTypeId
        serviceUsageId
      }
      serviceOriginId
      serviceId
      specialService {
        ...ResolvableServiceForm_ResolvableServiceBaseInterface_Fragment
      }
      index
      settings {
        showAmountsInQuotation {
          __typename
          mode
          resolverId
          value
          ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
        }
        showCostsInQuotation {
          __typename
          mode
          resolverId
          value
          ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
        }
        showMaterialsInQuotation {
          __typename
          mode
          resolverId
          value
          ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
        }
        showQuantitiesInQuotation {
          __typename
          mode
          resolverId
          value
          ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
        }
      }
      quantity {
        __typename
        value {
          __typename
          mode
          resolverId
          value
        }
        unitId {
          __typename
          mode
          resolverId
          value
        }
        ...ResolvableQuantityCmp_ResolvableQuantity_Fragment
      }
    }
  `);

export type ResolvableServiceUsageForm_ResolvableServiceUsage = ResultOf<
  typeof ResolvableServiceUsageForm_ResolvableServiceUsage_Fragment
>;

export interface RequiredResolvableServiceUsageFormContext {
  readonly serviceUsages: readonly ResolvableServiceUsageForm_ResolvableServiceUsage[];
}

export interface OptionalResolvableServiceUsageFormContext {
  readonly serviceUsages?: readonly ResolvableServiceUsageForm_ResolvableServiceUsage[];
}
